import React, { Component } from 'react';

import 'react-table/react-table.css';
import './LandlordPropertiesPage.css';

import OptionsDropdown from 'components/shared/OptionsDropdown';

import MenuItem from 'material-ui/MenuItem';

import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

class PropertiesMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(
      {
        tableSize: nextProps.data.length === 0 ? 5 : nextProps.data.length,
        data: nextProps.data,
      },
      function () {
        this.forceUpdate();
      }
    );
  }

  render() {
    return (
      <div className="mobile_card">
        {this.state.data.length === 0 && (
          <div id="mobile_card">
            <div className="row">
              <p
                style={{
                  textAlign: 'center',
                  color: 'rgba(0,0,0,0.5)',
                  marginTop: '13px',
                }}
              >
                {' '}
                No Properties{' '}
              </p>
            </div>
          </div>
        )}
        {this.state.data.map((item, i) => (
          <div id="mobile_card" key={i}>
            <div className="row">
              <div style={{ float: 'right', marginTop: '4px' }}>
                <OptionsDropdown
                  allowedOpen={
                    !this.props.abstractDialogVisible &&
                    !this.props.showDeleteDialog &&
                    !this.props.showInvitableDialog &&
                    !this.props.showDocumentDialogs &&
                    !this.props.showMaintenanceWaiverMessageDialog &&
                    !this.props.showProspectMessageDialog &&
                    !this.props.showGoogleReviewDialog &&
                    !this.props.showLegalNoticesDialog &&
                    !this.props.showRequestAssistanceDialog
                  }
                >
                  <MenuItem
                    primaryText={item.editable ? 'Edit Property' : 'View Property'}
                    onClick={() => this.props.propertyDetails(item.id)}
                    style={{ fontSize: '14px' }}
                  />
                  <MenuItem
                    primaryText="View Booking Link"
                    onClick={() => this.props.openAbstractDialog('bookingLink', item)}
                    style={{ fontSize: '14px' }}
                  />
                  <MenuItem
                    primaryText={item.invitable ? 'Turn off Invitations' : 'Enable Invitations'}
                    onClick={() => this.props.toggleInvitableDialog(item.id, item.invitable)}
                    style={{ fontSize: '14px' }}
                  />
                  <MenuItem
                    primaryText="View Property Documents"
                    onClick={() => this.props.openPropertyDocuments(item.id)}
                    style={{ fontSize: '14px' }}
                  />
                  <MenuItem
                    primaryText="Upload Property Documents"
                    onClick={() => this.props.toggleDocumentUploaderDialog(item.id)}
                    style={{ fontSize: '14px' }}
                  />
                  <MenuItem
                    primaryText={getTranslatedString(
                      'landlordPortal.properties.maintenanceDialogForResidents'
                    )}
                    onClick={() => this.props.toggleMaintenanceWaiverMessageDialog(item.id)}
                    style={{ fontSize: '14px' }}
                  />
                  <MenuItem
                    primaryText={getTranslatedString(
                      'landlordPortal.properties.applicationDialogForProspects'
                    )}
                    onClick={() => this.props.toggleProspectMessageDialog(item.id)}
                    style={{ fontSize: '14px' }}
                  />
                  {this.props.admin && this.props.googleEnabled && (
                    <MenuItem
                      primaryText={getTranslatedString(
                        `landlordPortal.properties.googleReviews.${
                          !item.google_reviews_active ? 'enable' : 'disable'
                        }`
                      )}
                      onClick={() => this.props.toggleGoogleReviewDialog(item.id)}
                      style={{ fontSize: '14px' }}
                    />
                  )}
                  {featureEnabled('legal_documents_as_notices') &&
                    this.props.legalNoticesEnabled && (
                      <MenuItem
                        primaryText={getTranslatedString(
                          `landlordPortal.properties.digitalLegalNotices.${
                            !item.can_send_legal_notices ? 'enable' : 'disable'
                          }`
                        )}
                        onClick={() => this.props.toggleLegalNoticesDialog(item.id)}
                        style={{ fontSize: '14px' }}
                      />
                    )}
                  {featureEnabled('ui.residents.request_assistance') && this.props.requestAssistanceEnabled && (
                    <MenuItem
                      primaryText={getTranslatedString(
                        `landlordPortal.properties.requestAssistance.${
                          item.enable_portal_assistance_request ? 'disable' : 'enable'
                        }Title`
                      )}
                      onClick={() => this.props.toggleRequestAssistanceDialog(item.id)}
                      style={{ fontSize: '14px' }}
                    />
                  )}
                  {this.props.admin && (
                    <MenuItem
                      primaryText="Inactivate Property"
                      onClick={() => this.props.toggleDeleteDialog(item.id)}
                      style={{ color: colors.RED, fontSize: '14px' }}
                    />
                  )}
                </OptionsDropdown>
              </div>
              <div className="mobile_header"> {item.name}</div>
              <div className="mobile_subheader"> Owner/Portfolio: {item.owner_or_portfolio}</div>
              <div className="mobile_subheader"> Occupancy: {item.occupancy_rate}</div>
              <div className="mobile_subheader"> Vacancies: {item.vancant_units} </div>
              <div className="mobile_subheader"> Turnovers: {item.turnovers} </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default PropertiesMobile;
